module.exports = __webpack_public_path__ + "static/media/logo.eaae4d63.webp";